import { Box, Flex } from '@chakra-ui/react'
import React from 'react'
import Sidebar from '../../../Components/Sidebar'
import Navbar from '../../../Components/Navbar'

const ExitManagement = () => {
  return (
    <Flex>
    <Sidebar />
    <Box pl={{ base: "2", md: "10" }}
      pt={{ base: "10", md: "10" }}
      w={{ base: "100%", md: "80%" }}>
      <Navbar />
      <br />
      <br />
      <Box>Exit Management</Box>
    </Box>
  </Flex>
  )
}

export default ExitManagement